
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_2h04i_98",
  "arrow": "awsui_arrow_18eso_2h04i_98",
  "has-caret": "awsui_has-caret_18eso_2h04i_136",
  "placeholder": "awsui_placeholder_18eso_2h04i_139",
  "pressed": "awsui_pressed_18eso_2h04i_152",
  "disabled": "awsui_disabled_18eso_2h04i_155",
  "in-filtering-token": "awsui_in-filtering-token_18eso_2h04i_164",
  "read-only": "awsui_read-only_18eso_2h04i_170",
  "invalid": "awsui_invalid_18eso_2h04i_187"
};
  